module.exports = __webpack_public_path__ + "static/img/wx_tips.bc63d78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wx_tips.jpg
// module id = 284
// module chunks = 0 1 2 3 4